class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle?.querySelector(':scope > summary');
    this.panel = this.summary?.nextElementSibling;

    if (!this.mainDetailsToggle || !this.summary || !this.panel) return;

    if (!this.panel.id) {
      DetailsDisclosure.panelId = (DetailsDisclosure.panelId || 0) + 1;
      this.panel.id = `HeaderDisclosurePanel-${DetailsDisclosure.panelId}`;
    }

    this.summary.setAttribute('aria-controls', this.panel.id);
    this.updateExpandedState();

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    this.updateExpandedState();

    if (!this.mainDetailsToggle.open) return;

    this.closest('ul')
      ?.querySelectorAll(':scope > li > details-disclosure > details[open]')
      .forEach((details) => {
        if (details !== this.mainDetailsToggle) details.removeAttribute('open');
      });
  }

  updateExpandedState() {
    this.summary?.setAttribute('aria-expanded', this.mainDetailsToggle.open);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.updateExpandedState();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
